// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.new-inactive-devices-report{
    position: absolute;
    top: 5vh;
    left: 15vw;
    width: 55vw;
    height: 60vh;
    padding: 0px;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
.new-inactive-devices-report-header{
    color: white;
    display: flex;
    padding: 15px 20px;
    justify-content: space-between;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.new-inactive-devices-report-header h3{
    margin: 0px;
    font-weight: lighter;
}
.new-inactive-devices-report-header p{
    margin: 0px;
    cursor: pointer;
}
.new-inactive-devices-report-navigation-bar{
    display: flex;
    padding: 4px 3px;
    justify-content: space-between;
    border-bottom: 1px solid rgb(179, 179, 179);
}
.save-new-inactive-devices-report-button-container{
    padding: 5px 30px;
}
#save-new-inactive-devices-report-button{
    color: white;
    border-radius: 50%;
    padding: 12px 16px;
    background-color: rgba(223, 77,30, 0.953);
}
.new-inactive-devices-report-schedule-button-container,
.new-inactive-devices-report-devices-button-container,
.new-inactive-devices-report-recipients-button-container{
    display: inline-block;
    padding: 12px 10px;
}
.new-inactive-devices-report-navigation-bar button{
    border: none;
    outline: none;
    margin: 0px;
    border-radius: 80px;
    padding: 8px 15px;
    cursor: pointer;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    background-color: transparent;
    transition: background-color 0.3s ease;
}
/*Message box*/
.new-inactive-devices-report-message-box-container{
    position: absolute;
    background-color: white;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    height: 15vh;
    width: 25vw;
    top: 22vh;
    left: 32vh;
    border-radius: 10px;
}
.new-inactive-devices-report-message-box-header{
    display: flex;
    color: white;
    padding: 10px 15px;
    justify-content: space-between;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.new-inactive-devices-report-message-box-header h3{
    margin: 0px;
    font-weight: lighter;
}
.new-inactive-devices-report-message-box-header p{
    margin: 0px;
    cursor: pointer;
}
.new-inactive-devices-report-message-box-body{
    padding: 0px 20px;
}
.new-inactive-devices-report-message-box-buttons-container{
    text-align: right;
    padding: 0px 20px;
}
.new-inactive-devices-report-message-box-buttons-container button{
    border: none;
    color: white;
    cursor: pointer;
    padding: 5px 14px;
    border-radius: 4px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    background-color: rgba(155, 30, 30, 0.952);
}
/*Details tab*/
.new-inactive-devices-report-details-tab-container{
    display: flex;
    margin: 10px;
    padding: 8vh 30px;
    border-radius: 10px;
    align-content: center;
    justify-content: left;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);
}
.new-inactive-devices-report-details-tab-container p{
    margin: 0px;
    margin-top: 8px;
    margin-right: 40px;
}
.new-inactive-devices-report-details-tab-container input{
    width: 25%;
    margin: 0px;
    border: none;
    outline: none;
    padding: 10px 20px;
    border-radius: 20px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
}
/*Devices tab*/
.new-inactive-devices-report-devices-controls-container{
    display: flex;
    padding: 20px 30px;
    justify-content: space-between;
}
.new-inactive-devices-report-devices-controls-container p{
    margin: 0px;
}
.new-inactive-devices-report-devices-controls-container button{
    border: none;
    color: white;
    cursor: pointer;
    padding: 5px 14px;
    border-radius: 4px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    background-color: rgba(155, 30, 30, 0.952);
}
.new-inactive-devices-report-devices-empty-table-container{
    width: 30vw;
    margin-top: 5vh;
    margin-left: 14vw;
    padding: 10px 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.new-inactive-devices-report-devices-empty-table-container h4{
    margin: 0px;
    font-size: 18px;
    text-align: center;
    font-weight: lighter;
}
.new-inactive-devices-report-devices-empty-table-container p{
    margin: 6px 0px;
}
.new-inactive-devices-report-devices-table-container{
    height: 30vh;
    margin: 5px 30px;
    padding: 2px 5px;
    overflow-y: auto;
}
.new-inactive-devices-report-devices-table-container table{
    width: 100%;
    margin: 0px;
    padding: 0px;
    font-size: 16px;
    text-align: left;
    table-layout: fixed;
    box-sizing: border-box;
    border-collapse: collapse;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
.new-inactive-devices-report-devices-table-container table tr:nth-child(odd){
    background-color: rgba(206, 206, 206,0.953);
}
#new-inactive-devices-report-devices-table-header-row{
    background-color: transparent;
}
.new-inactive-devices-report-devices-table-container table td,
.new-inactive-devices-report-devices-table-container table th{
    padding: 4px 0px;
}
.new-inactive-devices-report-devices-table-container table img{
    height: 20px;
    cursor: pointer;
}
.new-inactive-devices-report-devices-browser-container{
    position: absolute;
    background-color: white;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    height: 18vh;
    width: 24vw;
    top: 12vh;
    left: 28vh;
    border-radius: 10px;
}
.new-inactive-devices-report-devices-browser-header{
    display: flex;
    color: white;
    padding: 10px 15px;
    justify-content: space-between;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.new-inactive-devices-report-devices-browser-header h3{
    margin: 0px;
}
.new-inactive-devices-report-devices-browser-header p{
    margin: 0px;
    cursor: pointer;
}
.new-inactive-devices-report-devices-browser-body{
    display: flex;
    justify-content: center;
}
.new-inactive-devices-report-devices-browser-body select{
    width: 80%;
    padding: 8px;
    background-color: transparent;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
.new-inactive-devices-report-devices-browser-add-button-container{
    text-align: right;
    padding: 25px 10%;
}
.new-inactive-devices-report-devices-browser-add-button-container button{
    border: none;
    color: white;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 6px;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
}

/*Schedule tab*/
.new-inactive-devices-report-schedule-controls-container{
    display: flex;
    padding: 20px 30px;
    justify-content: space-between;
}
.new-inactive-devices-report-schedule-controls-container p{
    margin: 0px;
}
.new-inactive-devices-report-schedule-controls-container button{
    border: none;
    color: white;
    cursor: pointer;
    padding: 5px 14px;
    border-radius: 4px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    background-color: rgba(155, 30, 30, 0.952);
}
.new-inactive-devices-report-schedule-entries-empty-table-container{
    width: 30vw;
    margin-top: 5vh;
    margin-left: 14vw;
    padding: 10px 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.new-inactive-devices-report-schedule-entries-empty-table-container h4{
    margin: 0px;
    font-size: 18px;
    text-align: center;
    font-weight: lighter;
}
.new-inactive-devices-report-schedule-entries-empty-table-container p{
    margin: 6px 0px;
}
.new-inactive-devices-report-schedule-entries-table-container{
    height: 30vh;
    margin: 5px 30px;
    padding: 2px 5px;
    overflow-y: auto;
}
.new-inactive-devices-report-schedule-entries-table-container table{
    width: 100%;
    margin: 0px;
    padding: 0px;
    font-size: 16px;
    text-align: left;
    table-layout: fixed;
    box-sizing: border-box;
    border-collapse: collapse;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
#new-inactive-devices-report-schedule-entries-table-header-row{
    background-color: transparent;
}
.new-inactive-devices-report-schedule-entries-table-container table tr:nth-child(odd){
    background-color: rgba(206, 206, 206,0.953);
}
.new-inactive-devices-report-schedule-entries-table-container table th,
.new-inactive-devices-report-schedule-entries-table-container table td{
    padding: 4px 6px;
}
.new-inactive-devices-report-schedule-entries-table-container table th{
    font-weight: 700;
}
.new-inactive-devices-report-schedule-entries-table-container table td{
    font-weight: 500;
}
.new-inactive-devices-report-schedule-entries-table-container table img{
    height: 20px;
    cursor: pointer;
    padding: 4px 20px;
}
.new-inactive-devices-report-schedule-entries-table-container table div{
    display: flex;
    justify-content: center;
}
.new-report-schedule-entry-container{
    position: absolute;
    background-color: white;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    height: 32vh;
    width: 34vw;
    top: 12vh;
    left: 23vh;
    border-radius: 10px;
}
.new-report-schedule-entry-header{
    display: flex;
    color: white;
    padding: 10px 15px;
    justify-content: space-between;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.new-report-schedule-entry-header h4{
    margin: 0px;
    font-weight: lighter;
}
.new-report-schedule-entry-header p{
    margin: 0px;
    cursor: pointer;
}
.new-report-schedule-frequency-entry-container{
    display: grid;
    padding: 20px 60px;
    padding-bottom: 10px;
    align-content: center;
    grid-template-columns: 2fr 3fr;
}
.new-report-schedule-frequency-entry-container p{
    margin: 6px 0px;
}
.new-report-schedule-frequency-entry-container select{
    width: 60%;
    margin: 0px;
    padding: 6px;
    background-color: transparent;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
.new-report-schedule-time-entry-container{
    display: grid;
    padding: 10px 60px;
    align-content: center;
    grid-template-columns: 2fr 3fr;
}
.new-report-schedule-time-entry-container input{
    width: 54%;
    margin: 0px;
    height: 30px;
    border: none;
    outline: none;
    margin: 12px 0px;
    padding: 0px 10px;
    border-radius: 4px;
    background-color: transparent;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
.new-report-schedule-inactivity-threshold-entry-container{
    display: grid;
    padding: 20px 60px;
    padding-bottom: 10px;
    align-content: center;
    grid-template-columns: 2fr 3fr;
}
.new-report-schedule-inactivity-threshold-entry-container p{
    margin: 6px 0px;
}
.new-report-schedule-inactivity-threshold-entry-container select{
    width: 60%;
    margin: 0px;
    padding: 6px;
    background-color: transparent;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
.new-report-schedule-add-button-container{
    text-align: right;
    padding: 0px 30px;
}
.new-report-schedule-add-button-container button{
    border: none;
    color: white;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 6px;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
}
/*Recipients tab*/
.new-inactive-devices-report-recipients-controls-container{
    display: flex;
    padding: 20px 30px;
    justify-content: space-between;
}
.new-inactive-devices-report-recipients-controls-container p{
    margin: 0px;
}
.new-inactive-devices-report-recipients-controls-container button{
    border: none;
    color: white;
    cursor: pointer;
    padding: 5px 14px;
    border-radius: 4px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    background-color: rgba(155, 30, 30, 0.952);
}
.new-inactive-devices-report-recipients-empty-table-container{
    width: 30vw;
    margin-top: 5vh;
    margin-left: 14vw;
    padding: 10px 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.new-inactive-devices-report-recipients-empty-table-container h4{
    margin: 0px;
    font-size: 18px;
    text-align: center;
    font-weight: lighter;
}
.new-inactive-devices-report-recipients-empty-table-container p{
    margin: 6px 0px;
}
.new-inactive-devices-report-recipients-table-container{
    height: 30vh;
    margin: 5px 30px;
    padding: 2px 5px;
    overflow-y: auto;
}
.new-inactive-devices-report-recipients-table-container table{
    width: 100%;
    margin: 0px;
    padding: 0px;
    font-size: 16px;
    text-align: left;
    table-layout: fixed;
    box-sizing: border-box;
    border-collapse: collapse;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
#new-inactive-devices-report-recipients-table-header-row{
    background-color: transparent;
}
.new-inactive-devices-report-recipients-table-container table td,
.new-inactive-devices-report-recipients-table-container table th{
    padding: 4px 6px;
}
.new-inactive-devices-report-recipients-table-container table tr:nth-child(odd){
    background-color: rgba(206, 206, 206,0.953);
}
.new-inactive-devices-report-recipients-table-container table img{
    height: 20px;
    cursor: pointer;
}
.new-inactive-devices-report-new-recipient-entry-container{
    position: absolute;
    background-color: white;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    height: 23vh;
    width: 26vw;
    top: 12vh;
    left: 28vh;
    border-radius: 10px;
}
.new-inactive-devices-report-new-recipient-entry-header{
    display: flex;
    color: white;
    padding: 10px 15px;
    justify-content: space-between;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.new-inactive-devices-report-new-recipient-entry-header h3{
    margin: 0px;
}
.new-inactive-devices-report-new-recipient-entry-header p{
    margin: 0px;
    cursor: pointer;
}
.new-inactive-devices-report-new-recipient-entry-body{
    padding: 10px 15px;
}
.new-inactive-devices-report-new-recipient-name-container,
.new-inactive-devices-report-new-recipient-email-address-container{
    display: grid;
    padding: 10px;
    grid-template-columns: 2fr 3fr;
}
.new-inactive-devices-report-new-recipient-name-container p,
.new-inactive-devices-report-new-recipient-email-address-container p{
    margin: 0px;
}
.new-inactive-devices-report-new-recipient-name-container input,
.new-inactive-devices-report-new-recipient-email-address-container input{
    border: none;
    outline: none;
    padding: 6px 10px;
    border-radius: 4px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
}
.new-inactive-devices-report-new-recipient-add-button-container{
    text-align: right;
    padding:15px;
}
.new-inactive-devices-report-new-recipient-add-button-container button{
    border: none;
    color: white;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 6px;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/InactiveDevicesReports/NewInactiveDevicesReport.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;AAC9C;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,gCAAgC;IAChC,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,2CAA2C;AAC/C;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;AAC7C;AACA;;;IAGI,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,0CAA0C;IAC1C,6BAA6B;IAC7B,sCAAsC;AAC1C;AACA,cAAc;AACd;IACI,kBAAkB;IAClB,uBAAuB;IACvB,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,gCAAgC;IAChC,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA,cAAc;AACd;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;AACA,cAAc;AACd;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,0CAA0C;AAC9C;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,6BAA6B;AACjC;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,gCAAgC;IAChC,0CAA0C;AAC9C;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,YAAY;IACZ,6BAA6B;IAC7B,0CAA0C;AAC9C;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,0CAA0C;AAC9C;;AAEA,eAAe;AACf;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,0CAA0C;AAC9C;AACA;IACI,6BAA6B;AACjC;AACA;IACI,2CAA2C;AAC/C;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,gCAAgC;IAChC,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,8BAA8B;AAClC;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,0CAA0C;AAC9C;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA,iBAAiB;AACjB;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,0CAA0C;AAC9C;AACA;IACI,6BAA6B;AACjC;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,gCAAgC;IAChC,0CAA0C;AAC9C;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,aAAa;IACb,aAAa;IACb,8BAA8B;AAClC;AACA;;IAEI,WAAW;AACf;AACA;;IAEI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;AAC9C;AACA;IACI,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,0CAA0C;AAC9C","sourcesContent":["\r\n.new-inactive-devices-report{\r\n    position: absolute;\r\n    top: 5vh;\r\n    left: 15vw;\r\n    width: 55vw;\r\n    height: 60vh;\r\n    padding: 0px;\r\n    border-radius: 10px;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-inactive-devices-report-header{\r\n    color: white;\r\n    display: flex;\r\n    padding: 15px 20px;\r\n    justify-content: space-between;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.new-inactive-devices-report-header h3{\r\n    margin: 0px;\r\n    font-weight: lighter;\r\n}\r\n.new-inactive-devices-report-header p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n}\r\n.new-inactive-devices-report-navigation-bar{\r\n    display: flex;\r\n    padding: 4px 3px;\r\n    justify-content: space-between;\r\n    border-bottom: 1px solid rgb(179, 179, 179);\r\n}\r\n.save-new-inactive-devices-report-button-container{\r\n    padding: 5px 30px;\r\n}\r\n#save-new-inactive-devices-report-button{\r\n    color: white;\r\n    border-radius: 50%;\r\n    padding: 12px 16px;\r\n    background-color: rgba(223, 77,30, 0.953);\r\n}\r\n.new-inactive-devices-report-schedule-button-container,\r\n.new-inactive-devices-report-devices-button-container,\r\n.new-inactive-devices-report-recipients-button-container{\r\n    display: inline-block;\r\n    padding: 12px 10px;\r\n}\r\n.new-inactive-devices-report-navigation-bar button{\r\n    border: none;\r\n    outline: none;\r\n    margin: 0px;\r\n    border-radius: 80px;\r\n    padding: 8px 15px;\r\n    cursor: pointer;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    background-color: transparent;\r\n    transition: background-color 0.3s ease;\r\n}\r\n/*Message box*/\r\n.new-inactive-devices-report-message-box-container{\r\n    position: absolute;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    height: 15vh;\r\n    width: 25vw;\r\n    top: 22vh;\r\n    left: 32vh;\r\n    border-radius: 10px;\r\n}\r\n.new-inactive-devices-report-message-box-header{\r\n    display: flex;\r\n    color: white;\r\n    padding: 10px 15px;\r\n    justify-content: space-between;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.new-inactive-devices-report-message-box-header h3{\r\n    margin: 0px;\r\n    font-weight: lighter;\r\n}\r\n.new-inactive-devices-report-message-box-header p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n}\r\n.new-inactive-devices-report-message-box-body{\r\n    padding: 0px 20px;\r\n}\r\n.new-inactive-devices-report-message-box-buttons-container{\r\n    text-align: right;\r\n    padding: 0px 20px;\r\n}\r\n.new-inactive-devices-report-message-box-buttons-container button{\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    padding: 5px 14px;\r\n    border-radius: 4px;\r\n    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n/*Details tab*/\r\n.new-inactive-devices-report-details-tab-container{\r\n    display: flex;\r\n    margin: 10px;\r\n    padding: 8vh 30px;\r\n    border-radius: 10px;\r\n    align-content: center;\r\n    justify-content: left;\r\n    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-inactive-devices-report-details-tab-container p{\r\n    margin: 0px;\r\n    margin-top: 8px;\r\n    margin-right: 40px;\r\n}\r\n.new-inactive-devices-report-details-tab-container input{\r\n    width: 25%;\r\n    margin: 0px;\r\n    border: none;\r\n    outline: none;\r\n    padding: 10px 20px;\r\n    border-radius: 20px;\r\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);\r\n}\r\n/*Devices tab*/\r\n.new-inactive-devices-report-devices-controls-container{\r\n    display: flex;\r\n    padding: 20px 30px;\r\n    justify-content: space-between;\r\n}\r\n.new-inactive-devices-report-devices-controls-container p{\r\n    margin: 0px;\r\n}\r\n.new-inactive-devices-report-devices-controls-container button{\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    padding: 5px 14px;\r\n    border-radius: 4px;\r\n    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.new-inactive-devices-report-devices-empty-table-container{\r\n    width: 30vw;\r\n    margin-top: 5vh;\r\n    margin-left: 14vw;\r\n    padding: 10px 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-inactive-devices-report-devices-empty-table-container h4{\r\n    margin: 0px;\r\n    font-size: 18px;\r\n    text-align: center;\r\n    font-weight: lighter;\r\n}\r\n.new-inactive-devices-report-devices-empty-table-container p{\r\n    margin: 6px 0px;\r\n}\r\n.new-inactive-devices-report-devices-table-container{\r\n    height: 30vh;\r\n    margin: 5px 30px;\r\n    padding: 2px 5px;\r\n    overflow-y: auto;\r\n}\r\n.new-inactive-devices-report-devices-table-container table{\r\n    width: 100%;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    font-size: 16px;\r\n    text-align: left;\r\n    table-layout: fixed;\r\n    box-sizing: border-box;\r\n    border-collapse: collapse;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-inactive-devices-report-devices-table-container table tr:nth-child(odd){\r\n    background-color: rgba(206, 206, 206,0.953);\r\n}\r\n#new-inactive-devices-report-devices-table-header-row{\r\n    background-color: transparent;\r\n}\r\n.new-inactive-devices-report-devices-table-container table td,\r\n.new-inactive-devices-report-devices-table-container table th{\r\n    padding: 4px 0px;\r\n}\r\n.new-inactive-devices-report-devices-table-container table img{\r\n    height: 20px;\r\n    cursor: pointer;\r\n}\r\n.new-inactive-devices-report-devices-browser-container{\r\n    position: absolute;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    height: 18vh;\r\n    width: 24vw;\r\n    top: 12vh;\r\n    left: 28vh;\r\n    border-radius: 10px;\r\n}\r\n.new-inactive-devices-report-devices-browser-header{\r\n    display: flex;\r\n    color: white;\r\n    padding: 10px 15px;\r\n    justify-content: space-between;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.new-inactive-devices-report-devices-browser-header h3{\r\n    margin: 0px;\r\n}\r\n.new-inactive-devices-report-devices-browser-header p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n}\r\n.new-inactive-devices-report-devices-browser-body{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.new-inactive-devices-report-devices-browser-body select{\r\n    width: 80%;\r\n    padding: 8px;\r\n    background-color: transparent;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-inactive-devices-report-devices-browser-add-button-container{\r\n    text-align: right;\r\n    padding: 25px 10%;\r\n}\r\n.new-inactive-devices-report-devices-browser-add-button-container button{\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    padding: 8px 20px;\r\n    border-radius: 6px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n/*Schedule tab*/\r\n.new-inactive-devices-report-schedule-controls-container{\r\n    display: flex;\r\n    padding: 20px 30px;\r\n    justify-content: space-between;\r\n}\r\n.new-inactive-devices-report-schedule-controls-container p{\r\n    margin: 0px;\r\n}\r\n.new-inactive-devices-report-schedule-controls-container button{\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    padding: 5px 14px;\r\n    border-radius: 4px;\r\n    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.new-inactive-devices-report-schedule-entries-empty-table-container{\r\n    width: 30vw;\r\n    margin-top: 5vh;\r\n    margin-left: 14vw;\r\n    padding: 10px 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-inactive-devices-report-schedule-entries-empty-table-container h4{\r\n    margin: 0px;\r\n    font-size: 18px;\r\n    text-align: center;\r\n    font-weight: lighter;\r\n}\r\n.new-inactive-devices-report-schedule-entries-empty-table-container p{\r\n    margin: 6px 0px;\r\n}\r\n.new-inactive-devices-report-schedule-entries-table-container{\r\n    height: 30vh;\r\n    margin: 5px 30px;\r\n    padding: 2px 5px;\r\n    overflow-y: auto;\r\n}\r\n.new-inactive-devices-report-schedule-entries-table-container table{\r\n    width: 100%;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    font-size: 16px;\r\n    text-align: left;\r\n    table-layout: fixed;\r\n    box-sizing: border-box;\r\n    border-collapse: collapse;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n#new-inactive-devices-report-schedule-entries-table-header-row{\r\n    background-color: transparent;\r\n}\r\n.new-inactive-devices-report-schedule-entries-table-container table tr:nth-child(odd){\r\n    background-color: rgba(206, 206, 206,0.953);\r\n}\r\n.new-inactive-devices-report-schedule-entries-table-container table th,\r\n.new-inactive-devices-report-schedule-entries-table-container table td{\r\n    padding: 4px 6px;\r\n}\r\n.new-inactive-devices-report-schedule-entries-table-container table th{\r\n    font-weight: 700;\r\n}\r\n.new-inactive-devices-report-schedule-entries-table-container table td{\r\n    font-weight: 500;\r\n}\r\n.new-inactive-devices-report-schedule-entries-table-container table img{\r\n    height: 20px;\r\n    cursor: pointer;\r\n    padding: 4px 20px;\r\n}\r\n.new-inactive-devices-report-schedule-entries-table-container table div{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.new-report-schedule-entry-container{\r\n    position: absolute;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    height: 32vh;\r\n    width: 34vw;\r\n    top: 12vh;\r\n    left: 23vh;\r\n    border-radius: 10px;\r\n}\r\n.new-report-schedule-entry-header{\r\n    display: flex;\r\n    color: white;\r\n    padding: 10px 15px;\r\n    justify-content: space-between;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.new-report-schedule-entry-header h4{\r\n    margin: 0px;\r\n    font-weight: lighter;\r\n}\r\n.new-report-schedule-entry-header p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n}\r\n.new-report-schedule-frequency-entry-container{\r\n    display: grid;\r\n    padding: 20px 60px;\r\n    padding-bottom: 10px;\r\n    align-content: center;\r\n    grid-template-columns: 2fr 3fr;\r\n}\r\n.new-report-schedule-frequency-entry-container p{\r\n    margin: 6px 0px;\r\n}\r\n.new-report-schedule-frequency-entry-container select{\r\n    width: 60%;\r\n    margin: 0px;\r\n    padding: 6px;\r\n    background-color: transparent;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-report-schedule-time-entry-container{\r\n    display: grid;\r\n    padding: 10px 60px;\r\n    align-content: center;\r\n    grid-template-columns: 2fr 3fr;\r\n}\r\n.new-report-schedule-time-entry-container input{\r\n    width: 54%;\r\n    margin: 0px;\r\n    height: 30px;\r\n    border: none;\r\n    outline: none;\r\n    margin: 12px 0px;\r\n    padding: 0px 10px;\r\n    border-radius: 4px;\r\n    background-color: transparent;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-report-schedule-inactivity-threshold-entry-container{\r\n    display: grid;\r\n    padding: 20px 60px;\r\n    padding-bottom: 10px;\r\n    align-content: center;\r\n    grid-template-columns: 2fr 3fr;\r\n}\r\n.new-report-schedule-inactivity-threshold-entry-container p{\r\n    margin: 6px 0px;\r\n}\r\n.new-report-schedule-inactivity-threshold-entry-container select{\r\n    width: 60%;\r\n    margin: 0px;\r\n    padding: 6px;\r\n    background-color: transparent;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-report-schedule-add-button-container{\r\n    text-align: right;\r\n    padding: 0px 30px;\r\n}\r\n.new-report-schedule-add-button-container button{\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    padding: 8px 20px;\r\n    border-radius: 6px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n/*Recipients tab*/\r\n.new-inactive-devices-report-recipients-controls-container{\r\n    display: flex;\r\n    padding: 20px 30px;\r\n    justify-content: space-between;\r\n}\r\n.new-inactive-devices-report-recipients-controls-container p{\r\n    margin: 0px;\r\n}\r\n.new-inactive-devices-report-recipients-controls-container button{\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    padding: 5px 14px;\r\n    border-radius: 4px;\r\n    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.new-inactive-devices-report-recipients-empty-table-container{\r\n    width: 30vw;\r\n    margin-top: 5vh;\r\n    margin-left: 14vw;\r\n    padding: 10px 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-inactive-devices-report-recipients-empty-table-container h4{\r\n    margin: 0px;\r\n    font-size: 18px;\r\n    text-align: center;\r\n    font-weight: lighter;\r\n}\r\n.new-inactive-devices-report-recipients-empty-table-container p{\r\n    margin: 6px 0px;\r\n}\r\n.new-inactive-devices-report-recipients-table-container{\r\n    height: 30vh;\r\n    margin: 5px 30px;\r\n    padding: 2px 5px;\r\n    overflow-y: auto;\r\n}\r\n.new-inactive-devices-report-recipients-table-container table{\r\n    width: 100%;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    font-size: 16px;\r\n    text-align: left;\r\n    table-layout: fixed;\r\n    box-sizing: border-box;\r\n    border-collapse: collapse;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n#new-inactive-devices-report-recipients-table-header-row{\r\n    background-color: transparent;\r\n}\r\n.new-inactive-devices-report-recipients-table-container table td,\r\n.new-inactive-devices-report-recipients-table-container table th{\r\n    padding: 4px 6px;\r\n}\r\n.new-inactive-devices-report-recipients-table-container table tr:nth-child(odd){\r\n    background-color: rgba(206, 206, 206,0.953);\r\n}\r\n.new-inactive-devices-report-recipients-table-container table img{\r\n    height: 20px;\r\n    cursor: pointer;\r\n}\r\n.new-inactive-devices-report-new-recipient-entry-container{\r\n    position: absolute;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    height: 23vh;\r\n    width: 26vw;\r\n    top: 12vh;\r\n    left: 28vh;\r\n    border-radius: 10px;\r\n}\r\n.new-inactive-devices-report-new-recipient-entry-header{\r\n    display: flex;\r\n    color: white;\r\n    padding: 10px 15px;\r\n    justify-content: space-between;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.new-inactive-devices-report-new-recipient-entry-header h3{\r\n    margin: 0px;\r\n}\r\n.new-inactive-devices-report-new-recipient-entry-header p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n}\r\n.new-inactive-devices-report-new-recipient-entry-body{\r\n    padding: 10px 15px;\r\n}\r\n.new-inactive-devices-report-new-recipient-name-container,\r\n.new-inactive-devices-report-new-recipient-email-address-container{\r\n    display: grid;\r\n    padding: 10px;\r\n    grid-template-columns: 2fr 3fr;\r\n}\r\n.new-inactive-devices-report-new-recipient-name-container p,\r\n.new-inactive-devices-report-new-recipient-email-address-container p{\r\n    margin: 0px;\r\n}\r\n.new-inactive-devices-report-new-recipient-name-container input,\r\n.new-inactive-devices-report-new-recipient-email-address-container input{\r\n    border: none;\r\n    outline: none;\r\n    padding: 6px 10px;\r\n    border-radius: 4px;\r\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-inactive-devices-report-new-recipient-add-button-container{\r\n    text-align: right;\r\n    padding:15px;\r\n}\r\n.new-inactive-devices-report-new-recipient-add-button-container button{\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    padding: 8px 20px;\r\n    border-radius: 6px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
